import React, { Component } from 'react';
import { Col, Container, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Route } from 'react-router';
import { push as routerPush } from 'react-router-redux';
import URI from 'urijs';

// components
import FooterForm from './FooterForm';
import Termly from '../../components/termly';

// modules
import styles from '../Containers.module.scss';
import BS from '../../theme/Bootstrap';

// images
import imgNabor from './images/nabor.png';
import imgRealtor from './images/realtor.png';
import imgFooter from './images/footer.jpg';

class AppFooter extends Component {
  render() {
    return (
      <Container fluid className={styles.footer}>
        <Route
          exact
          path="/"
          render={() => (
            <div className={styles.footerSearch}>
              <div className={styles.imgWrap}>
                <div className={styles.imgWrapInner}>
                  <img
                    src={imgFooter}
                    alt="Beachfront Property"
                    className={styles.footerImage}
                  />
                </div>
              </div>
              <Container className={`${BS.positionRelative}`}>
                <Row>
                  <Col
                    xs={12}
                    sm={{ size: 10, offset: 1 }}
                    md={{ size: 10, offset: 1 }}
                    lg={{ size: 7, offset: 3 }}
                    xl={{ size: 6, offset: 3 }}
                  >
                    <h2 className={BS.textLeft}>What can we help you find?</h2>
                    <FooterForm
                      onSubmit={this.handleSubmit}
                      initialValues={{
                        maxPrice: 500000
                      }}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          )}
        />
        <Container>
          <Row>
            <Col
              xs={12}
              sm={{ size: 'auto' }}
              className={`${BS.dFlex} ${BS.justifyContentEvenly} ${BS.alignItemsCenter} ${BS.mb3} ${BS.mbSm0}`}
            >
              <img src={imgNabor} alt="Nabor Logo" className={styles.naborLogo} />
              <img
                src={imgRealtor}
                alt="Realtor Logo"
                className={`${styles.realtorLogo} ${BS.mlSm2} `}
              />
            </Col>
            <Col>
              <p
                className={`${BS.colorOrangeLight}  ${BS.textJustify} ${BS.textSmRight}`}
              >
                NaplesArea.com is a website provided by the Naples Area Board of REALTORS
                <sup>®</sup> (NABOR<sup>®</sup>). The website is designed to help connect
                buyers and renters with Naples area REALTORS
                <sup>®</sup> and properties.
              </p>

              <Nav
                horizontal="evenly"
                className={`${BS.navDark} ${BS.justifyContentMdEnd}`}
              >
                <LinkContainer exact to="/">
                  <NavItem>
                    <NavLink href="/">Home</NavLink>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/find-naples-home">
                  <NavItem>
                    <NavLink href="/find-naples-home">Property Search</NavLink>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/find-naples-agent">
                  <NavItem>
                    <NavLink href="/find-naples-agent">
                      Find a REALTOR<sup>®</sup>
                    </NavLink>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/blog">
                  <NavItem>
                    <NavLink href="/blog">Blog</NavLink>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/resources">
                  <NavItem>
                    <NavLink href="/resources">Resources</NavLink>
                  </NavItem>
                </LinkContainer>
              </Nav>

              <p className={`${styles.copyright} ${BS.textCenter} ${BS.textSmRight}`}>
                Copyright © 2021 Naples Area Board of REALTORS<sup>®</sup>
              </p>

              <Nav
                horizontal="evenly"
                className={`${BS.navDarkTwo} ${BS.justifyContentMdEnd}`}
              >
                <LinkContainer to="/about">
                  <NavItem>
                    <NavLink href="/about">About</NavLink>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/contact-us">
                  <NavItem>
                    <NavLink href="/contact-us">Contact Us</NavLink>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/terms-of-use">
                  <NavItem>
                    <NavLink href="/terms-of-use">Terms of Use</NavLink>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/privacy-policy">
                  <NavItem>
                    <NavLink href="/privacy-policy">Privacy Policy</NavLink>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/dmca-policy">
                  <NavItem>
                    <NavLink href="/dmca-policy">DMCA Policy</NavLink>
                  </NavItem>
                </LinkContainer>
                <NavItem>
                  <NavLink href="#" className="termly-display-preferences">
                    Consent Preferences
                  </NavLink>
                </NavItem>
              </Nav>

              <p className={`${styles.notice} ${BS.textJustify} ${BS.textSmRight}`}>
                REALTOR<sup>®</sup> is a federally registered collective membership mark
                which identifies a real estate professional who is a member of the
                NATIONAL ASSOCIATION OF REALTOR<sup>®</sup> and subscribes to its strict
                Code of Ethics.
              </p>
            </Col>
          </Row>
        </Container>
        <Termly
          autoBlock
          masterConsentsOrigin="https://naplesarea.com"
          websiteUUID="615e280c-7653-4c51-8ae2-686928e1d8a3"
        />
      </Container>
    );
  }

  handleSubmit(values, dispatch, props) {
    return dispatch(routerPush(URI('/find-naples-home').search(values).toString()));
  }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/containers/App/Footer.js